import { makeStyles } from "@material-ui/core";
import { h4Medium, h5Medium } from "../../../shared/typography";
import { pointer } from "../../../shared/mixins";

export const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    // True viewport-height centering (rather than excluding the fixed
    // header's height from the centering math, which biased the form
    // toward the bottom half of the screen). The card is short enough
    // that this still clears the ~120px fixed header on any normal
    // screen size.
    minHeight: "100vh",
  },
  title: {
    ...h4Medium,
  },
  card: {
    background: "#FFF",
    width: "100%",
    maxWidth: 350,
    boxSizing: "border-box",
    padding: 15,
    borderRadius: 16,
    marginTop: 15,
  },
  submitButton: {
    ...h5Medium,
    ...pointer,
    width: "100%",
    border: "none",
    borderRadius: 16,
    height: 36,
    textAlign: "center",
    background: "#80BB34",
    color: "#FFFFFF",
    marginTop: 24,
    "&:disabled": {
      opacity: 0.5,
      cursor: "default",
    },
  },
}));
